import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type MarketSettingsSpiderSpiderDashboardController from 'lumen/controllers/market/settings/spider/spider-dashboard';
import getEnv from 'lumen/helpers/get-env';

interface MarketSettingsSpiderSpiderDashboardSignature {
  Args: {
    controller: MarketSettingsSpiderSpiderDashboardController;
    model: unknown;
  };
}

<template>
  <GeneralEmbeddedApp
    {{! @glint-expect-error: Incorrect type }}
    @baseURL={{getEnv "spiderIframeURL"}}
    @id="spider-settings"
    @query={{@controller.iframeQPs}}
    @url={{concat
      "/portfolios/"
      @controller.model.id
      "/"
      @controller.dashboard
    }}
  />
</template> satisfies TOC<MarketSettingsSpiderSpiderDashboardSignature>;
